import React from "react";
import { IconPropsModel } from "./tools/Icon.model";

export const Icon = ({
  className,
  children,
  isDecorativeOnly = true,
  testId
}: IconPropsModel) => {

  if (!React.isValidElement(children)) {
    return <>{children}</>;
  }

  const a11yProps = isDecorativeOnly
    ? { focusable: false, "aria-hidden": true }
    : {};

  return React.cloneElement(children, {
    className,
    "data-type": "ui/Icon",
    "data-testid": testId,
    ...a11yProps,
  } as Record<string, unknown>);
};
